import BaseApiAction from "@Actions/base-api-action";

export default class GetSessionResults extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({ name: "sessions-getSessionResults", payload: this._payload });
  }
}
